import InteriorDoorMeasurementValues from './InteriorDoorMeasurementValues';

export default InteriorDoorMeasurementValues ;